"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FakeDistrictsClient = void 0;
class FakeDistrictsClient {
    constructor() {
        this.usaDistricts = {};
    }
    clear() {
        this.usaDistricts = {};
    }
    setUsaDistricts(districtsByState) {
        this.usaDistricts = districtsByState;
    }
    searchUsaDistricts(state, query) {
        const districtsForState = this.usaDistricts[state];
        if (districtsForState == null) {
            return Promise.resolve([]);
        }
        return Promise.resolve(districtsForState.filter((district) => district.name.includes(query)));
    }
}
exports.FakeDistrictsClient = FakeDistrictsClient;
//# sourceMappingURL=FakeDistrictsClient.js.map